import { breakpoints, colors } from '@web-for-marketing/react-ui';

export const articleContentAreaStyles = {
    container: {
        margin: '0',
        padding: '5rem',
        boxShadow: '0px 15px 15px rgba(102, 120, 140, .41)',
        background: '#FFFFFF 0% 0% no-repeat padding-box',
        [`@media (max-width: ${breakpoints.sm})`]: {
            padding: '3rem 9.6vw 4rem',
        },
    },
    mainContainer: {
        margin: '0',
        padding: '5rem',
        boxShadow: '0 1.5rem 1.5rem rgb(102 120 140 / 40%)',
        background: '#FFFFFF',
        [`@media (max-width: ${breakpoints.md})`]: {
            padding: 0,
            boxShadow: 'none',
        },
    },
    title: {
        marginBottom: '1rem',
        width: '100%',
        [`@media (max-width: ${breakpoints.sm})`]: {
            fontSize: '3.6rem',
        },
    },
    blogDescription: {
        fontWeight: 400,
        marginBottom: '3rem',
    },
    subHeading: {
        fontSize: '3.2rem',
        fontWeight: 400,
        color: colors.core.innovation,
        marginBottom: 0,
        [`@media (max-width: ${breakpoints.md})`]: {
            fontSize: '2rem',
            marginBottom: '0',
        },
    },
    content: {
        marginTop: '2.5rem',
        [`@media (max-width: ${breakpoints.sm})`]: {
            marginTop: '1.5rem',
        },
    },
    publishedDate: {
        marginTop: '0.6em',
        [`@media (max-width: ${breakpoints.sm})`]: {
            fontSize: '1.8rem',
            fontWeight: 'bold',
        },
    },
    publishedContainer: {
        flexWrap: 'nowrap',
        justifyContent: 'space-between',
        [`@media (max-width: ${breakpoints.sm})`]: {
            flexWrap: 'wrap',
        },
    },
    dividerTop: {
        margin: '3rem 0',
        width: '100%',
        [`@media (max-width: ${breakpoints.md})`]: {
            margin: '2rem 0',
        },
    },
    dividerBottom: {
        margin: '5rem 0 6rem',
        width: '100%',
        [`@media (max-width: ${breakpoints.md})`]: {
            margin: '4rem 0',
        },
    },
    media: {
        display: 'none',
        [`@media (max-width: ${breakpoints.md})`]: {
            display: 'block',
            marginTop: '2rem',
            marginBottom: '2rem',
        },
    },
    tags: {
        marginTop: '2rem',
        [`@media (max-width: ${breakpoints.md})`]: {
            margin: '3rem 0 0',
        },
    },
    downloadButton: {
        marginTop: '4rem',
    },
    downloadContainer: {
        [`@media (max-width: ${breakpoints.sm})`]: {
            marginTop: '1rem',
        },
    },
    downloadBtnWrapper: {
        marginLeft: 'auto',
        [`@media (max-width: ${breakpoints.sm})`]: {
            margin: '1rem auto 0',
        },
    },
    bodyText: {
        fontSize: '1.6rem',
    },
    bodySubtitle: {
        marginBottom: '1rem',
    },
    displayContainer: {
        marginBottom: '0',
    },
    shareAndLikeIcons: {
        display: 'flex',
    },
    roundShareIcon: {
        padding: '0 !important',
        margin: '12px',
    },
    fixMargin: {
        outline: 'none',
        [`@media (max-width: ${breakpoints.md})`]: {
            margin: '2.5rem 0 1rem 0',
        },
    },
    authorLink: {
        display: 'block',

        '&:focus': {
            outline: 'none',
        },
        '&:active': {
            outline: 'none',
        },

        '&:focus div:first-child': {
            backgroundColor: '#E7F4FD',
        },
        '&:hover div:first-child': {
            backgroundColor: '#E7F4FD',
        },
        '&:active div:first-child': {
            backgroundColor: '#E7F4FD',
        },
    },
    iframeMedia: {
        position: 'relative',
        overflow: 'hidden',
        width: '100%',
        paddingTop: '56.25%',
        margin: '2rem 0',
    },
    videoMedia: {
        width: '100%',
        margin: '2rem 0',
        '& > iframe': {
            height: '100%',
            position: 'absolute',
            width: '100%',
            top: 0,
            left: 0,
        },
    },
    responsiveIframe: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        width: '100%',
        height: '100%',
    },
} as const;
